<template>
    <div v-if="visible" class='drag2' :class="{'isWidth':isZoom}">
        <div
            class="call-wrapper"
            :class="{PC: os == 'PC', 'shrink': shrink_wrapper == true}"
            :style="wrapper_style"
          >
          <!-- 放大缩小图标 -->
          <div class="zoom" @click.stop="zoomW()">
            <img :src="zoom" alt="">
          </div>
          <!-- 移动端 UI start -->
           <div class="desc">
              <div class="avater">
                <img :src="computeName['headImg'] || gril_default" >
              </div>
              <div class="info">
                <h2>{{computeName["name"]}}</h2>
                <p>{{pointMsg}}</p>
              </div>
            </div>

            <!-- 移动端 UI end -->
            <video v-show="callType == 'video'" ref='localVideo' @click="toggleClick" :class="{main: toggle, small: !toggle}" autoPlay muted playsInline/>
            <video v-show="callType == 'video'" ref='remoteVideo' @click="toggleClick" :class="{main: !toggle, small: toggle}" autoPlay playsInline />

            <div
                v-if="call_status == 'calling' && call_role != 'caller' "
                class="accept"
                @click="accept"><i></i><em>接听</em>
            </div>
            <div
                v-if="call_status == 'calling' && call_role != 'caller' "
                class="close"
                @click="refuse"><i></i><em>拒绝</em>
            </div>
           <div v-else class="close close_center" @click="hangup"><i></i><em>挂断</em></div> 
        </div>

        <div class="audio">
          <!--隐藏audio标签-->
          <audio loop="loop" preload ref="music">
            <source src="/static/mp3/audio.mp3">
          </audio>
        </div>

    </div>
</template>

<script>
import "./index.scss";
import WebIM from "@/utils/WebIM";
import gril_default from '@/assets/images/hr.png';
import zoom from '@/assets/images/zoom.png';
export default {
    data(){
        return {
            visible: false,
            user:  WebIM.conn.user || (localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo')).userId),
            gril_default,
            zoom,
            // 开始实现
            confr_info: null,
            userId:'',
            join_info: null,
            pushedStream: null,
            callType: "video",
            make_call_type: "single", // 1v1 | 多人

            joined: false, // 是否在会议中， 在会议中则返回 忙碌
            remotes: [], // 需要订阅的流（发起方的流 -- 暂时先不订阅）
            call_role: null, // caller: 主叫，callee: 被叫
            from: undefined,

            wait_invite_cattr_timeout: true, // 默认等待 邀请的会议属性 超时，收到会议属性后，置为false，达到5s 后，还是true hangup
            waiting_invitees: [], // 被邀请人员 还在等待响应的
            invitee_attr_timers: {}, // 会议属性等待开启定时

            // 与 UI紧关联
            call_status: undefined, // 通话的状态 "joined": 加入会议, "calling": 振铃, "talking": 通话中
            title: "",
            pointMsg:'',
            mic_close: false,
            camera_close: false,
            sound_close: false,
            wrapper_style: {
                width: "auto",
                height: "auto",
            },
            shrink_wrapper: false, // 移动端是否收起
            os: "",
            toggle: true,
            isZoom:false,
        };
    },

        // 计算属性方法
    computed: {
      
        // 计算头像名称
        computeName() {
            // 获取缓存中的信息
            const sessionInfo = this.$store.state.chat.userListStu.contactUserList;
            // 获取当前聊天用户信息
            const currentUserInfo = sessionInfo.filter(item => item.name == this.userId);
            // 判断当前用户是否存在
            if (currentUserInfo.length > 0) return {
                name: currentUserInfo[0]['nick'],
                headImg: currentUserInfo[0]['headImg']
            }

            return {
                name: "***",
                headImg: gril_default
            }
        }
    },
    
    methods: {
        // 开始实现
        onStreamAdded(member, stream){
            console.log("streamAdd", stream);

            if (!stream.located()){
                this.$data.remotes.push({ member, stream }); // 都保存


                // 主叫 立即订阅
                if (this.call_role != "callee"){
                    this.sub_remotes();
                    this.$data.call_status = "talking";
                    this.$data.title = "正在通话中";

                    let { name } = this.$data.remotes[0].member;
                    this.$data.title = "正在与" + name + "进行通话中";
                }
                
                let { name } = member;
                let _arrs = name.split("_");

                let uid = _arrs[_arrs.length - 1];

                if (uid == this.$data.user){ // 收到相同用户发流
                    console.log("hangup onStreamAdded uid == this.$data.user");
                    this.$Message.error('已在其他设备处理');
                    this.hangup();
                }
                else {
                    let index = this.$data.waiting_invitees.indexOf(uid);
                    if (index > -1){
                        this.$data.waiting_invitees.splice(index, 1);// 删除占位符
                        clearTimeout(this.$data.invitee_attr_timers[uid]);
                        this.check_mems();
                    }
                }
            }

        },
        // 切换大小窗口
        toggleClick(){
            this.$data.toggle = !this.$data.toggle;
        },
        // 窗口放大缩小
        zoomW() {
          this.isZoom = !this.isZoom
        },
        onMemberJoined(member){
            console.log("memberAdd", member);
        },
        onMemberExited(member){
            console.log("memberExited", member);

            this.check_mems();
        },
        onConferenceExit(reason, failed){
            let reasons = {
                0: "正常挂断",
                1: "没响应",
                2: "服务器拒绝",
                3: "对方忙",
                4: "网络原因",
                5: "不支持",
                6: "超时",
                10: "其他设备登录",
                11: "会议关闭",
                12: "被踢出了会议"
            };

            console.log("onConferenceExit", reason);
            if (reason == 12 || reason == 10){
                this.$Message.error('已在其他设备处理');
                this.reset();
            }
        },
        onConfrAttrsUpdated(confr_attrs){
            console.log("onConfrAttrsUpdated", JSON.stringify(confr_attrs));

            // 区分是否是自己的 uid,以此判断 是主叫还是被叫
            let invitee_attrs = confr_attrs
                .filter(item => (item.key.indexOf("invitee_") > -1 && item.op != "DEL"));

            let del_invitee_attrs = confr_attrs
                .filter(item => (item.key.indexOf("invitee_") > -1 && item.op == "DEL"));


            if (invitee_attrs.length > 0) console.log("invitee_attrs", JSON.stringify(invitee_attrs));
            if (del_invitee_attrs.length > 0) console.log("del_invitee_attrs", JSON.stringify(del_invitee_attrs));




            // {key: "invitee_ysai", val: "{"status":"calling"}", op: ""}
            let _this = this;

            // 收到invitee 会议属性，设置超时定时器
            // 有处理或者超时，都删除
            invitee_attrs.map(item => {

                let uid = item.key.split("_")[1];

                
                if (uid){
                    if (uid == _this.$data.user){
                       _this.show_calling(); 
                        
                    }
                    else {
                        _this.$data.waiting_invitees.push(uid);

                        // 设置被邀请方 超时定时器
                        _this.$data.invitee_attr_timers[uid] = setTimeout(() => {
                            console.log("invitee timeout", uid);
    
                            let index = _this.$data.waiting_invitees.indexOf(uid);
                            if (index > -1){// 超时删除邀请人员 会议属性 --- 所有人都能删
                                _this.emedia.deleteConferenceAttrs({ key: "invitee_" + uid, val: JSON.stringify({ status: "timeout" }) });
                            }
                        }, 30000);

                    }
                }
            });

            // 收到删除invitee 会议属性
            del_invitee_attrs.map(item => {
                let uid = item.key.split("_")[1];
                if (uid == _this.$data.user){ // 多端登录
                
                    if (_this.$data.call_status != "talking"){// 自己如果 talking, 则忽略(自己删除的会议属性)
                        console.log("hangup del_invitee_attrs != talking");

                        _this.hangup();
                    }
                }
                else { // 邀请的信息已处理或超时后的被删掉 会议属性

                    if (item.val){
                        let val = JSON.parse(item.val);
                        let msg = {
                            refuse: "对方已拒绝",
                            timeout: "对方忙",
                            busy: "对方正在通话中"
                        };

                        if (msg[val.status]) _this.$Message.error(msg[val.status]);
                    }

                    let index = _this.$data.waiting_invitees.indexOf(uid);
                    if (index > -1){ // 去除 等待邀请人员 -- 停止超时器

                        _this.$data.waiting_invitees.splice(index, 1);// 删除占位符
                        clearTimeout(_this.$data.invitee_attr_timers[uid]);
                        this.check_mems();
                    }
                }
            });

        },

        // 检测会议中的人数
        check_mems(){
            let { waiting_invitees } = this.$data;

            let _cacheMembers;

            if (
                emedia.useCurrentXService
                && emedia.useCurrentXService.current
                && emedia.useCurrentXService.current._cacheMembers
            ){
                _cacheMembers = emedia.useCurrentXService.current._cacheMembers;
            }

            console.log("waiting_invitees", waiting_invitees);

            if (waiting_invitees > 0) return;

            console.log("_cacheMembers", _cacheMembers);
            if (Object.keys(_cacheMembers).length > 0) return; // _cacheMembers 不包含自己的信息

            if (this.$data.make_call_type == "single" && this.$data.call_status == "talking") this.$Message.error("对方已挂断");
            this.hangup();
        },


        async ready_call(){
            const confr_info = await this._create();
            this.$data.confr_info = confr_info;

            const join_info = await this.join();
            this.$data.join_info = join_info;

            await this.publish();
            

        },
    

        
        // 整个程序收到消息 判断是否请求通话
        receivedMsg(msg){
            // console.log("call com onMsg", msg);
            if (msg.from == this.$data.user) return; // 自己的另一端发送的
            this.user =  WebIM.conn.user || (localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo')).userId);
            this.userId = msg.from
            if (msg.data == "call busy"){ // 收到忙碌消息
                let index = this.$data.waiting_invitees.indexOf(msg.from);
                if (index > -1){
                    this.emedia.deleteConferenceAttrs({
                        key: "invitee_" + msg.from,
                        val: JSON.stringify({ status: "busy" })
                    });
                }
                return;
            }


            // 收到 邀请通话 消息

            if (this.$data.join_info){ // 正在会议中
                console.warn("has jioned meeting");

                // send busy msg
                let id = WebIM.conn.getUniqueId();
                let busy_msg = new WebIM.message("txt", id);

                let set_options = {
                    msg: "call busy",
                    to: msg.from,
                    chatType: "singleChat",
                    success: function(id, serverMsgId){
                        console.log("send busy msg success");
                    },
                    fail: function(e){
                        console.error("Send busy msg error", e);
                    }
                };

                busy_msg.set(set_options);
                WebIM.conn.send(busy_msg.body);

                return;
            }


            if (!msg.ext){
                console.log("not have msg.ext");
                return;
            }

            let { confrId, password } = msg.ext;
            if (!confrId || !password){
                console.log("not have ext.confrId or password");
                return;
            }

            this.invited_join(msg);

        },

        // 收到邀请，加入会议
        async invited_join(msg){

            this.$data.confr_info = { confrId: msg.ext.confrId, password: msg.ext.password };
            this.$data.callType = msg.ext.callType;

            try {
                this.$data.call_role = "callee";
                this.$data.from = msg.from;

                const join_info = await this.join();
                this.$data.join_info = join_info;


                this.$data.wait_invite_cattr_timer = setTimeout(() => {
                    // 5s 后还没收到 邀请自己的会议属性 退出会议
                    if (this.$data.wait_invite_cattr_timeout){
                        console.log("hangup 5s 后还没收到 邀请自己的会议属性 退出会议");
                        this.hangup();
                    }
                }, 5000);
            }
            catch (error){
                console.error("called join error", error);
                this.reset();
            }

        },

        // 振铃
        show_calling(){
            this.$data.visible = true;
            this.$nextTick(() => {
                let audio = this.$refs.music;
                audio.currentTime = 0;
                audio.play();
            })
            let word = this.callType =='video'?'视频':'语音'
            this.pointMsg = `邀请你${word}通话`
            this.$data.wait_invite_cattr_timeout = false; 
            clearTimeout(this.$data.wait_invite_cattr_timer);
            this.$data.call_status = "calling";
            this.$emit("swtichVideoOral", true,word,this.userId);
        },
        // 创建会议
        _create(){
            let _this = this;
            let password = _this.get_uuid_psw();
            let create_options = {
                confrType: 10,
                password,
                supportWechatMiniProgram: true
            };
            return this.emedia.createConference(create_options);

        },

        join(){
            if (!this.$data.confr_info){
                throw Error("not have confr_info");
            }

            let { confrId, password } = this.$data.confr_info;

            return this.emedia.joinUsePassword(confrId, password);
        },

        publish(){
            let constraints = this.$data.callType == "voice" ?
                { audio: true, video: false } : { audio: true, video: true };


            let _this = this;
            return new Promise((resolve, reject) => {
                _this.emedia.publish(constraints).then(pushedStream => {
                    _this.$data.pushedStream = pushedStream;
                    _this.emedia.streamBindVideo(_this.$data.pushedStream, _this.$refs.localVideo);

                    resolve("publish success");
                })
                    ["catch"](error => reject(error));
            });

        },
        
        // 接听
        accept(){
            let _this = this;
            (async () => {
                try {
                    await _this.publish();
                    _this.$data.call_status = "talking";
                    let audio = _this.$refs.music;
                    audio.pause();
                    let word = _this.callType =='video'?'视频':'语音'
                    _this.pointMsg = `${word}通话中...`
                    _this.emedia.deleteConferenceAttrs({
                        key: "invitee_" + _this.$data.user,
                        val: JSON.stringify({ status: "accept" })
                    });

                    _this.sub_remotes();
                }
                catch (error){
                    console.log("accept error", error);
                    _this.$Message.error("接听失败，请重新接听");
                }
            })();
        },
        // 订阅对方流
        sub_remotes(){
            let { remotes } = this.$data;

            if (this.$data.make_call_type == "single"){
                let remote = remotes[0];
                if (remote.member && remote.stream){
                    this.emedia.subscribe(remote.member, remote.stream, true, true, this.$refs.remoteVideo);
                }
            }
        },
        // 拒绝
        refuse(){
            let audio = this.$refs.music;
            audio.pause();
            this.emedia.deleteConferenceAttrs({
                key: "invitee_" + this.$data.user,
                val: JSON.stringify({ status: "refuse" }),
                success: this.hangup,
                error: this.hangup
            });
            this.$data.visible = false;
        },
        // 挂断
        hangup() { // 多种情况会触发 挂断
            this.emedia.exitConference();
            let word = this.callType =='video'?'视频':'语音'
            this.$emit("swtichVideoOral", false,word,this.userId);
            this.reset(); 
        },

        _destroy(){
            let confr_info = this.$data.confr_info;

            if (confr_info && confr_info.id){
                this.emedia.destroyConference(confr_info.id);
            }
        },


        // 重置
        reset(){

            for (const key in this.$data.invitee_attr_timers){
                let timer = this.$data.invitee_attr_timers[key];

                clearTimeout(timer);
            }
            Object.assign(this.$data,
                this.$options.data(),
                { os: this.$data.os, wrapper_style: this.$data.wrapper_style }
            ); // os、wrapper_style 不重置
            emedia.mgr.catrrs = []; // 无法更新 SDK，临时改一下

            if (process.env.NODE_ENV == "development") console.clear();
        },


        // 控制视频流
        controlAudio(){
            let { pushedStream } = this.$data;

            if (!pushedStream) return;

            let funName = this.$data.mic_close ? "resumeAudio" : "pauseAudio";

            let _this = this;
            this.emedia[funName](pushedStream)
                .then(() => {
                    _this.$data.mic_close = !_this.$data.mic_close;
                });
            
        },

        controlVideo(){
            let { pushedStream } = this.$data;

            if (!pushedStream) return;

            let funName = this.$data.camera_close ? "resumeVideo" : "pauseVideo";

            let _this = this;
            this.emedia[funName](pushedStream)
                .then(() => {
                    _this.$data.camera_close = !_this.$data.camera_close;
                });
        },

        controlSound(){
            this.$data.sound_close = !this.$data.sound_close;
        },

        // 随机生成密码
        get_uuid_psw(){
            return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c){
                let r = Math.random() * 6 | 0,
                    v = c == "x" ? r : (r & 0x3 | 0x8);
                return v.toString(6);
            });
        },

    },
    watch: {
        shrink_wrapper: function(val){
            if (val){
                this.$data.wrapper_style = {
                    width: window.innerWidth * 0.2 + "px",
                    height: window.innerHeight * 0.2 + "px"
                };
            }
            else {
                this.$data.wrapper_style = {
                    width: window.innerWidth + "px",
                    height: window.innerHeight + "px"
                };
            }
        },

        callType: function(val){
            if (this.$data.callType == "voice") this.$data.camera_close = true;
        }
        
    },
    updated(){
        if (!this.visible) return;

        // document.querySelector("#drag2").style.top = 0;
        // document.querySelector("#drag2").style.left = 0;
    },
    mounted(){
        WebIM.EMService = emedia.mgr;
        this.emedia = WebIM.EMService; // 多人会议 SDK --- 不包含 1v1
        emedia.config({ // 取全局 window.emedia
            restPrefix: "https://a1.easemob.com"
        });

        // 初始化会议监听
        this.emedia.onMemberJoined = this.onMemberJoined; // 有人加入
        this.emedia.onMemberExited = this.onMemberExited; // 有人加入
        this.emedia.onStreamAdded = this.onStreamAdded; // 有流加入
        this.emedia.onConferenceExit = this.onConferenceExit; // 退出会议
        this.emedia.onConfrAttrsUpdated = this.onConfrAttrsUpdated; // 会议属性变更
        
        // 页面刷新 退出会议
        let _this = this;
        window.onbeforeunload = () => {
            _this.emedia.exitConference();
            _this.reset();
        };
        // 检测设备 是否 PC


        // 检测设备操作系统
        let UA = navigator.userAgent;

        if (UA.indexOf("Android") > -1){
            this.$data.os = "Android";
        }
        else if (
            UA.indexOf("iPhone") > -1 ||
                UA.indexOf("iPad") > -1 ||
                UA.indexOf("iPod") > -1
        ){ // iPad、iPod 都使用 iPhone 下载连接
            this.$data.os = "iPhone";
        }
        else this.$data.os = "PC";

        if (this.$data.os == "PC"){
            this.$data.wrapper_style = {
                width: "100%",
                height: "100%"
            };
        }
        else {

            this.$data.wrapper_style = {
                // width: window.innerWidth + "px",
                // height: window.innerHeight + "px"
            };

        }

    },
    
    
};
</script>
<style lang="scss" scoped>
.drag2 {
  position:absolute;
  z-index:1000;
  top:50%;
  left:50%;
  -webkit-transform:translate(-50%,-50%);
  transform:translate(-50%,-50%);
  width: 600px;
  height: 500px; 
}
.isWidth {
  width:100%;
  height: 100%;
}
.call-wrapper {
    background: #4b4b4b;
    transition: 0.5s;
    width:100%;
    height: 100%;
  .zoom {
    position: absolute;
    top:30px;
    right:30px;
    z-index: 100000;
    cursor: pointer;
    img {
      display: block;
      width:34px;
      height: 34px;
    }
  }
 .desc {
      position: absolute;
      top:30px;
      left:30px;
      z-index: 100000;
      overflow: hidden;
      .avater {
        width:76px;
        height: 76px;
        flex-shrink: 0;
        border-radius: 50%;
        float: left;
        img {
          display: block;
          width:100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .info {
        margin-left: 20px;
        color: #fff;
        float: left;
        h2 {
          font-size: 16px;
          line-height: 24px;
          color: #fff;
          margin: 10px 0;
        }
        p {
          font-size: 14px;
          line-height: 22px;
        }
      }
    }

.shrink.call-wrapper {
    position: absolute;
    top: 200px;
    left: 0;
    transition: 0.5s;
}

video.main {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    object-fit: cover;
}

.shrink video.main {
    z-index: 5;
    background:#dadada;
}
.PC video.small {
    position: absolute;
    width: 25%;
    height: 20%;
    top: 10%;
    right: 5%;
    z-index: 100;
}

video.small {
    position: absolute;
    width: 35%;
    height: 20%;
    top: 10%;
    right: 5%;
    z-index: 100;
}

.callees-placeholder-wrapper{
    position: absolute;
    width: 25%;
    height: 20%;
    top: 10%;
    right: 5%;
}

.shrink-wrapper {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 32px;
    height: 32px;
    z-index: 2;
}

.shrink-wrapper i {
    color: #fff;
    font-size: 16px;
    font-weight: bold;
}
.shrink-wrapper i:first-child {
    position: absolute;
    top: 0;
    right: 0;
}
.shrink-wrapper i:last-child {
    position: absolute;
    bottom: 0;
    left: 0;
}
}
</style>



// WEBPACK FOOTER //
// src/components/MessageManage/Components/SingleCallUseEmedia/index.vue